import { Injectable } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from 'src/app/core/constants/url.constants';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { SubmitQuoteModel } from '../../../core/model/submit-quote-model';
import { QuoteEditModel } from '../../../core/model/quote-edit-model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { pipe } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { QuoteTabNameModel } from '../../../core/model/quote-tab-name-model';
import moment from 'moment';
import { WindowRef } from '@spartacus/core';
import { ThemeService } from '@spartacus/storefront';
import { TenderTabNameModel } from 'src/app/core/model/tender-tab-name-model';
@Injectable({
  providedIn: 'root'
})
export class CustomProductsService {
  userid;
  quotesData: any;
  query = '';
  queryForQuote = '';
  filterValue: any = null;
  products: any;
  quoteTabNameModel = new QuoteTabNameModel();
  productData$: Observable<any>;
  contactData: any;
  addData: any;
  bidPlaced = false;
  cancelled = false;
  isRedirectFromQuotesDetails = false;
  quoteStatusName = null;
  private notificationChnageSub = new BehaviorSubject(null);
  notificationChnageSub$ = this.notificationChnageSub.asObservable();
  private filterSortSearchSubject = new BehaviorSubject(null);
  filterSortSearchSubject$ = this.filterSortSearchSubject.asObservable();
  private refreshCarouselComp = new BehaviorSubject(null);
  private refreshCarouselCompProduct = new BehaviorSubject(null);
  private refreshCarouselCompAll = new BehaviorSubject(null);
  private logout = new BehaviorSubject(null);
  logout$ = this.logout.asObservable();
  lang = 'en';
  refreshComp$ = this.refreshCarouselComp.asObservable();
  refreshCompProduct$ = this.refreshCarouselCompProduct.asObservable();
  refreshCompAll$ = this.refreshCarouselCompAll.asObservable();
  private userName = new BehaviorSubject(null);
  userName$ = this.userName.asObservable();
  userGroup: any;
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();

  private sortChange = new BehaviorSubject('relevance');
  sortChange$ = this.sortChange.asObservable();

  private searchInput = new BehaviorSubject(null);
  searchInput$ = this.searchInput.asObservable();

  private filterInput = new BehaviorSubject(null);
  filterInput$ = this.filterInput.asObservable();

  private filterValues = new BehaviorSubject(null);
  filterValues$ = this.filterValues.asObservable();

  private searchValue = new BehaviorSubject(null);
  searchValue$ = this.searchValue.asObservable();

  private tendersearchValue = new BehaviorSubject(null);
  tendersearchValue$ = this.searchValue.asObservable();


  private homeLinkActive = new BehaviorSubject(true);
  homeLinkActive$: any;

  private userIdChange = new BehaviorSubject(null);
  userIdChange$ = this.userIdChange.asObservable();

  private privacypolicy = new BehaviorSubject(null);
  privacyPolicyValue = this.privacypolicy.asObservable();

  private isAgentInvoiceActiveSub = new BehaviorSubject<string>('');
  isAgentInvoiceActiveObv = this.isAgentInvoiceActiveSub.asObservable();

  date: any;
  hour: any;
  min: any;
  second:any;
  usergroup: any;
  expiring: string;
  tenderTabNameModel= new TenderTabNameModel();

  private isShipmentPage = new BehaviorSubject(null);
  isShipmentPage$ = this.isShipmentPage.asObservable();

  private isShipmentDetailPage = new BehaviorSubject(null);
  isShipmentDetailPage$ = this.isShipmentDetailPage.asObservable();
  
  private statusBarInput = new BehaviorSubject(null);
  statusBarInput$ = this.statusBarInput.asObservable();

  getShipmentStatusInfo(value): any {
    this.statusBarInput.next(value);
  }

  isShipmentPageFunction(value){
    this.isShipmentPage.next(value)
  }
  isShipmentDetailPageFunction(value){
    this.isShipmentDetailPage.next(value)
  }
  getNotificationValue(value): any {
    this.notificationChnageSub.next(value);
  }
  getLogout(value): any {
    this.logout.next(value);
  }
  refreshFunction(value): any {
    this.refreshCarouselComp.next(value);
  }
  refreshFunctionProduct(value): any {
    this.refreshCarouselCompProduct.next(value);
  }
  refreshFunctionAll(value): any {
    this.refreshCarouselCompAll.next(value);
  }
  getUserDetails(value): any {
    this.userName.next(value);
  }

  getLanguageChange(value): any {
    console.log('129')
    this.languageChange.next(value);
  }

  getSearchInput(value): any {
    this.searchInput.next(value);
  }

  getsearchValue(value): any {
    this.searchValue.next(value);
  }
  gettendersearchValue(value): any {
    this.tendersearchValue.next(value);
  }

  getFilterInput(value): any {
    this.filterInput.next(value);
  }

  getFilterValues(value): any {
    this.filterValues.next(value);
  }
    getsortChange(value): any {
    this.sortChange.next(value);
  }

  getFilterSortSearchInput(value): any {
    this.filterSortSearchSubject.next(value);
  }

  private confirmTxt: BehaviorSubject<any> = new BehaviorSubject(null);
    getConfirmtxt(): Observable<any> {
        return this.confirmTxt.asObservable();
    }
    setConfirmtxt(txt: string) {
        this.confirmTxt.next(txt);
    }

  private acceptTxt: BehaviorSubject<any> = new BehaviorSubject(null);
    getAccepttxt(): Observable<any> {
        return this.acceptTxt.asObservable();
    }
    setAccepttxt(txt: string) {
        this.acceptTxt.next(txt);
    }
   
  setprivacyValues(values:any) {
      this.privacypolicy.next(values);
  }


  private shipStatus: BehaviorSubject<any> = new BehaviorSubject(null);
    getShipstatus(): Observable<any> {
        return this.shipStatus.asObservable();
    }
    setShipstatus(txt: string) {
        this.shipStatus.next(txt);
    }
  constructor(private httpUtilService: HttpUtilService,
              private translation: TranslationService,
              private userAccountFacade: UserAccountFacade,
              private winRef: WindowRef,
              private httpClient:HttpClient
  ) {
    this.getGroupCompany();
    console.log('193');
    this.homeLinkActive$ = this.homeLinkActive.asObservable();
    this.translation.translate('home.myAccount.language').subscribe(res => {
      this.lang = res;
      this.getLanguageChange(res);
    });
    // this.translation.translate('home.quote.Expiringin').subscribe(res => {
    //   this.expiring = res;
    //   this.getLanguageChange(res);
    // });
    // this.translation.translate('home.quote.d').subscribe(res => {
    //   this.date = res;
    //   this.getLanguageChange(res);
    // });
    // this.translation.translate('home.quote.h').subscribe(res => {
    //   this.hour = res;
    //   this.getLanguageChange(res);
    // });
    // this.translation.translate('home.quote.m').subscribe(res => {
    //   this.min = res;
    //   this.getLanguageChange(res);
    // });
    // this.translation.translate('home.quote.s').subscribe(res => {
    //   this.second = res;
    //   this.getLanguageChange(res);
    // });

    this.userAccountFacade.get().subscribe(data => {
      if (data) {
        this.userid = data.uid;
        this.userIdChange.next(this.userid);
        //  this.usergroup  = data.orgUnit.uid
        // this.userGroupName = data.orgUnit.name;
      }
    });
  }

  getProducts(currentPage?, pageSize?, sort?, searchInput?): Observable<any> {
    // this.getsortChange(sort);
    // tslint:disable-next-line:max-line-length
    this.usergroup=this.getGroupCompany();
    if (!searchInput) {
      return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput).GET_BROWSE_BY_PRODUCTS);
    } else {
    return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput)
    .GET_BROWSE_BY_PRODUCTS_WITH_SEARCH);
    }

  }
  getAllProducts(currentPage?, pageSize?, sort?, searchInput?): Observable<any> {
    // this.getsortChange(sort);
    // tslint:disable-next-line:max-line-length
    this.usergroup=this.getGroupCompany();
    if (!searchInput) {
      return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput)
        .GET_BROWSE_BY_ALL);
    } else {
      return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput)
        .GET_BROWSE_BY_ALL_WITH_SEARCH);
    }
  }

  getHomeLinkActive(value): any {
    this.homeLinkActive.next(value);
  }

  getBrowseByPortsData(currentPage?, pageSize?, sort?, searchInput?): Observable<any> {
    if (!searchInput) {
      return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput)
        .GET_BROWSE_BY_PORT);

    } else {
      return this.httpUtilService.get(Constants.getgroupuser('', this.usergroup, this.lang, currentPage, pageSize, sort, searchInput)
        .GET_BROWSE_BY_PORT_WITH_SEARCH);
    }
  }

  createQuote(quoteModel: SubmitQuoteModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        observe: 'response'
      })
    };
    this.getGroupCompany();
    quoteModel.buyerID = this.userid;
    return this.httpUtilService.post(Constants.createBid(this.userid, this.userGroup).CREATEQUOTE, quoteModel,
      httpOptions);
  }
  EditQuote(quoteModel: QuoteEditModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        observe: 'response'
      })
    };
    this.getGroupCompany();
    quoteModel.buyerID = this.userid;
    return this.httpUtilService.post(Constants.createBid(this.userid,  this.userGroup).CREATEQUOTE, quoteModel,
      httpOptions);
  }
  getQuotesDetails(quoteId): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.getBidData(this.userid, this.userGroup, quoteId, this.lang).GET_BID_DETAILS, 'token');
  }
  getQuotesListData(quoteStatus?: string,location?,commodity?, startDate?, endDate?, searchInput?, materials?): Observable<any> {
    this.queryForQuote = '';
    this.getGroupCompany();
    if (quoteStatus === 'completed') {
      quoteStatus = this.quoteTabNameModel.accepted;
    } else if (quoteStatus === 'archived') {
      quoteStatus = this.quoteTabNameModel.archived;
    } else if (quoteStatus === 'active') {
      quoteStatus = this.quoteTabNameModel.active;
    }
    if (location != null  && location !== undefined && location != '') {
            this.queryForQuote += `&shipTo=${location}`;
      }
    // if (quoteStatus !== this.quoteTabNameModel.active) {
      if (startDate != null && endDate != null && startDate !== undefined && endDate !== undefined) {
        this.queryForQuote += `&creationDateTo=${endDate}&creationDateFrom=${startDate}`;
      }
      // this.queryForQuote = this.queryForQuote.substring(1);
    // }
    if (searchInput != null && searchInput !== undefined && searchInput !== '') {
      this.queryForQuote += `&searchText=${searchInput}`;
    }
    if (materials !== null && materials !== undefined && materials != '') {
      this.queryForQuote += `&materials=${materials}`;
    }
    if(commodity !== null && commodity != '' && commodity !== undefined){
      this.queryForQuote += `&commodityType=${commodity}`;
    }
// return this.httpClient.get('/assets/quoteList.json')
    return this.httpUtilService.get(Constants.getBidData(this.userid, this.userGroup, 
      quoteStatus, this.lang, this.queryForQuote).GET_BID_LIST, 'token');
  }

  getMasterData(): Observable<any> {
    return this.httpUtilService.get(Constants.getgroupuser('', '', this.lang).MASTERDATA);
  }
  getContractFilters(status: string): Observable<any>{
        this.query = '';
        this.getGroupCompany();
       if (status !== null && status !== undefined && status!='') {
      this.query += `&status=${status}`;
    }
         return this.httpUtilService.get(Constants.getFilterContract(this.userid,this.userGroup, this.query ).GET_FILTERCONTRACT);

  }
  getContractData(startDate?, endDate?, status?, product?, search?): Observable<any> {

    // tslint:disable-next-line:max-line-length
    this.query = '';
    this.getGroupCompany();
    if (startDate !== null && endDate !== null && startDate !== undefined && endDate !== undefined) {
      this.query += `&ctContractEndDate=${endDate}&ctContractStartDate=${startDate}`;
    }
    if (status !== null && status !== undefined && status!='') {
      this.query += `&status=${status}`;
    }
    if (product !== null && product !== undefined && product!='') {
      this.query += `&productId=${product}`;
    }
    if (search !== null && search !== '' && search !== undefined) {
      this.query += `&searchText=${search}`;
    }
    //return this.httpClient.get('/assets/contracts.json')

     return this.httpUtilService.get(Constants.getContractFilter(this.userid, this.userGroup, this.query).GET_CONTRACTS_LIST);
  }
  scrollToTop(): any {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }
  convertDateForCounterOffer(dataD): any {
    const data = new Date(dataD);
    const month = data.getMonth() + 1;
    const day = data.getDate();
    let dayString;
    let monthString;
    const year = data.getFullYear();
    if (day <= 9) {
      dayString = '0' + day;
    } else {
      dayString = day;
    }
    if (month < 10) {
      monthString = '0' + month;
    } else {
      monthString = month;
    }
    const postDate = year + '-' + monthString + '-' + dayString;
    return postDate;
  }

  expiryCalculate(validityDate): any {
    let counterTime = '';
    validityDate = moment(validityDate);
    const eventTime1 = validityDate.format(); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
    const eventTime: any = moment(eventTime1).format('X');
    const currentTime: any = moment().format('X'); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
    const diffTime = eventTime - currentTime;
    let duration: any = moment.duration(diffTime * 1000, 'milliseconds');
    const interval = 1000;
    duration = moment.duration(duration - interval, 'milliseconds');
    const dayRem = duration.days();
    const hRem = duration.hours();
    const mRem = duration.minutes();
    const sRem = duration.seconds();

    
    if(this.lang == 'en'){
      counterTime = this.expiring;
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        if(sRem > 0){
          counterTime += sRem + this.second;

        }
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0 && sRem <= 0) {
          counterTime = '';
        }
      }
    }
    if(this.lang == 'zh'){
      counterTime = '';
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        counterTime += this.expiring
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0) {
          counterTime = '';
        }
      }
    }
    return counterTime;
  }
  getGroupCompany(): any{
    this.userGroup = this.winRef.localStorage.getItem('groupCompany');
    return this.userGroup;
  }
  getMessageFromBundle(tab){
    let text;
    if (tab ==='UPCOMING'){
      text = 'shipment_upcoming';
    }else if(tab ==='INPROGRESS'){
      text = 'shipment_inprogress';
    }else if(tab ==='COMPLETED'){
      text = 'shipment_completed';
    }
    return this.httpUtilService.get(Constants.getMessageFromBundle(text,this.lang).MESSAGE);
  }
  getShipmentData(tab,currentPage?,startDate?, endDate?, status?,commodity?, product?, searchText?, sortData?): Observable<any> {
    this.query = '';
    this.getGroupCompany();
    if (startDate !== null  && startDate !== undefined && endDate !== null && endDate !== undefined ) {
      this.query += `&startDate=${startDate}&endDate=${endDate}`;
    }
  //   if( endDate !== null && endDate !== undefined){
  //   this.query=`&endDate=${endDate}`;
  // }
    if (status !== null && status !== undefined) {
      this.query += `&shippingStatus=${status}`;
    }
    if (commodity !== null && commodity !== undefined && commodity != '') {
      this.query += `&query=commodityType:${commodity}`;
    }
    if (product !== null && product !== undefined && product != '') {
      this.query += `&materials=${product}`;
    }
    if (searchText !== null && searchText !== '' && searchText !== undefined) {
      this.query += `&searchText=${searchText}`;
    }
    if (sortData !== null && sortData !== '' && sortData !== undefined) {
      this.query += `&sortBy=${sortData}`;
    }
    //return this.httpClient.get('/assets/shipmentList.json')
    return this.httpUtilService.get(Constants.getShipmentList(this.userid, tab, this.userGroup, currentPage,this.query).SHIPMENT_LIST);
}

  getShipmentDetailsData(shipmentId: any, dischargePoint: any, loadPort: any,loadPortCountry:any, destinationCountry:any){
    //console.log(this.userid);
    this.getGroupCompany();
    return  this.httpUtilService.get(Constants.getShipmentDetailsData(this.userid,this.userGroup,shipmentId,dischargePoint,loadPort).SHIPMENT_DETAILS);
    //return this.httpClient.get("/assets/ShipmentDetails.json")
  }
  getSdocsString(documentID: any, setID?: any,nominationKey?:any,nominationKeyItem?:any){
    return this.httpUtilService.get(Constants.getSdocsString(this.userid,documentID,setID,nominationKey,nominationKeyItem).BASE64);
  }
  getEDRData(ExternalQuoteID: any){
    return this.httpUtilService.get(Constants.getEDRDetails(this.userid,ExternalQuoteID).SCRM_EDR);
  }
  // open negoations services
  getTendersData(currentPage?:any ,tenderStatus?: string ,commodity?:any,startDate?, endDate?, materials?,searchText?):Observable<any>{
      this.query = ''
      this.getGroupCompany();
     if (tenderStatus === 'expired') {
        tenderStatus = this.tenderTabNameModel.expired;
      } else if (tenderStatus === 'active') {
        tenderStatus = this.tenderTabNameModel.active;
      }
      if (startDate !== null  && startDate !== undefined && endDate !== null && endDate !== undefined ) {
        this.query += `&startDate=${startDate}&endDate=${endDate}`;
      }
      if (materials !== null && materials !== undefined && materials != '') {
        this.query += `&materials=${materials}`;
      }
      if (searchText !== null && searchText !== '' && searchText !== undefined) {
        this.query += `&searchText=${searchText}`;
      }
      if(commodity !== null && commodity != '' && commodity !== undefined){
        this.query += `&commodityType=${commodity}`;
      }
      //return this.httpClient.get("/assets/tenderList.json");
      return this.httpUtilService.get(Constants.getTenders(this.userid,this.userGroup,currentPage,tenderStatus,this.query).TENDERS_DATA);
  }
  // getTendersData():any{
  //   return this.httpClient.get("/assets/tenderList.json").pipe(map((response: any) => response));
  // }

  submitTender(data: any){
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     observe: 'response'
    //   })
    // };
    // return this.httpClient.post("/assets/tenderList.json").pipe(map((response: any) => response));
    return this.httpUtilService.post(Constants.submitTender(this.userid,this.userGroup).SAVE_TENDER, data);
  }
  getTendersQuoteListData():any{
    // return this.httpClient.get(Constants.getTenders(this.userid,this.userGroup,currentPage).TENDERS_DATA).pipe(map((response: any) => response));
    return this.httpClient.get("/assets/quoteList.json").pipe(map((response: any) => response));
   }
   getTendersQuoteDetailsData():any{
    // return this.httpClient.get(Constants.getTenders(this.userid,this.userGroup,currentPage).TENDERS_DATA).pipe(map((response: any) => response));
    return this.httpClient.get("/assets/quoteDetail.json").pipe(map((response: any) => response));
   }
  getPDFData(quoteID: any){
    return this.httpUtilService.get(Constants.getPDFDetails(this.userid,quoteID).SCRM_PDF);
  }
  getBidAttachmentData(c4cUUID:any){
    return this.httpUtilService.get(Constants.getBidAttachment(this.userid,c4cUUID).BID_ATTACHMENT);
  }
  formatQPDates(dataFromHTML){
    if(dataFromHTML?.defaultQuotationPeriod?.finalQPDateFrom && dataFromHTML?.defaultQuotationPeriod?.finalQPDateTo){
      let formatedQPDateFROM =  new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateFrom).getDate() + '/' + 
                                (new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateFrom).getMonth()+1) + '/' +
                                new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateFrom).getFullYear() 
      let formatedQPDateTo =  new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateTo).getDate() + '/' + 
                                (new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateTo).getMonth()+1) + '/' +
                                new Date(dataFromHTML.defaultQuotationPeriod.finalQPDateTo).getFullYear() 
      return formatedQPDateFROM + ' - ' + formatedQPDateTo + ' (both dates inclusive)';
    }
    else{
      return dataFromHTML?.defaultQuotationPeriod?.description?dataFromHTML.defaultQuotationPeriod.description:'--'
    }
  }
  getLabelofConfirmScreen(priceOptions,commodityType,page){
    if(priceOptions.pricingOptions=='INDEX_PRICE' || priceOptions.pricingOptions=='LUMP_FIXED_PRICE'){
      if(commodityType=='CC'){
        if(page=='ITB'){
          return 'Your premium/discount';
        }
        else{
          return 'Premium/discount';
        }
        
      }
      else{
        if(page=='ITB'){
          return 'Your premium/discount (per '+ priceOptions.priceUnitDesc+')';
        }
        else{
          return 'Premium/discount (per '+ priceOptions.priceUnitDesc+')';
        }
        
      }
    }
    else if(priceOptions.pricingOptions=='FIXED_PRICE'){
      if(page=='ITB'){
        return 'Your price (per ' + priceOptions.priceUnitDesc+')';
      }
      else{
        return 'Price (per ' + priceOptions.priceUnitDesc+')';
      }
      
    }
    else if(priceOptions.pricingOptions=='FIXED_PREMIUM'){
      if(page=='ITB'){
        return 'Your premium (per ' + priceOptions.priceUnitDesc+')';
      }else{
        return 'Premium (per ' + priceOptions.priceUnitDesc+')';
      }
      
      
    }

  }
  getPriceandSymbol(priceOptions,price,commodityType){
  if(priceOptions.pricingOptions=='INDEX_PRICE' || priceOptions.pricingOptions=='LUMP_FIXED_PRICE'){
    if(commodityType=='IO'){
      return 'USD '+price;
    }
    else{
      return price +' %';
    }
      
    }
    else if(priceOptions.pricingOptions=='FIXED_PRICE' || priceOptions.pricingOptions=='FIXED_PREMIUM'){
      return 'USD '+price;
    }
  }
  getLabel(priceOptions, commodityType) {
    if (priceOptions.pricingOptions != 'FIXED_PRICE') {
      if(commodityType=='CA'){
        return `tenders.Enteryourpremium`;
      }else{
        return `tenders.PremiumDiscount`;
      }
    }
    else if (priceOptions.pricingOptions == 'FIXED_PRICE') {
      return `tenders.Enteryourprice`;
    }
  }
  getUnit(priceOptions,commodityType){
    if(commodityType=='CC' && priceOptions.pricingOptions=='INDEX_PRICE'){
      return '';
    }
    else{
      return ' (per '+priceOptions.priceUnitDesc+')';
    }
  }
  getPrefix(priceOptions,commodityType){
    if(priceOptions.pricingOptions=='INDEX_PRICE' && commodityType=='CC'){
      return '%';
    }
    else{
      return 'USD';
    }

  }
  convertDateIntoYYYYMMDDFormat(date){
    if(date){
      let dateFromTobeFormattedArray = date.split('-');
      let NewFormatedDateinDesiredFormat = '';
      if(dateFromTobeFormattedArray.length>0){
        NewFormatedDateinDesiredFormat = dateFromTobeFormattedArray[2]+'-'+dateFromTobeFormattedArray[1]+'-'+dateFromTobeFormattedArray[0]
      }
      return NewFormatedDateinDesiredFormat
    }
    
  }

getPricingBasisBasedOnOption(pricingOption,description:string){
  if(pricingOption == 'LUMP_FIXED_PRICE'){
    if(description){
        let split = description.split('+');
        return split[0];
      }
      else{
        return '--'
      }
    }
    else{
      return description;
    }
  }
  getPremiumIndex(premiumIndex:string){
   
    if(premiumIndex != undefined ){
      return premiumIndex;
    }

  }


  getvesselNomination(shipmentId: any, vesselStatus: any){
    return this.httpUtilService.get(Constants.getvesselNomination(this.userid,this.userGroup,shipmentId,vesselStatus).VESSELDATA, vesselStatus);
  }
  acceptOrRejectNomination(shipmentId: any,vesselStatus: any, vesselRemarks: any){
    return this.httpUtilService.post(Constants.vesselNomination(this.userid,this.userGroup, shipmentId, vesselStatus, vesselRemarks).VESSEL_NOMINATION, vesselRemarks);
  }
  getClass(count:number):string {
    if(count===2){
      return 'btn btn-block btn-light m-0 border1 space';
    }
   else if(count===3){
      return 'btn btn-block btn-light m-0 border space';
    }
    
  }
  getShipmentListData(data?,searchText?,display?) {
    // this.query = '';
    let query = ``;
    this.usergroup=this.getGroupCompany();
    if (data?.status !== null && data?.status !== undefined) {
      query += `&status=${data?.status}`.split(',').join(':');
    }
    if (data?.port !== null && data?.port !== undefined && data?.port != '') {
      query += `&port=${data?.port}`.split(',').join(':');
    }
    if(searchText !== null && searchText !== undefined && searchText != ''){
      query += `&searchText=${searchText}`;
    }
    // return this.httpClient.get("/assets/shipment.json").pipe(map((response: any) => response));
    return this.httpUtilService.get(Constants.getShipmentData(data,query,searchText,this.usergroup,this.userid,display).SHIPMENT_LIST);
}
  getShipmentInspectionListData(data?,searchText?,display?){
    let query = ``;
    this.usergroup=this.getGroupCompany();
    if (data?.status !== null && data?.status !== undefined) {
      query += `&status=${data?.status}`.split(',').join(':');
    }
    if (data?.port !== null && data?.port !== undefined && data?.port != '') {
      query += `&port=${data?.port}`.split(',').join(':');
    } 
    if(searchText !== null && searchText !== undefined && searchText != ''){
      query += `&searchText=${searchText}`;
    }
    if(display === 'bondedwarehouseInspectionPage'){
      query += `&salesArea=BW`;
    }
    //return this.httpClient.get("/assets/shipmentlist_1.json").pipe(map((response: any) => response));
    return this.httpUtilService.get(Constants.getShipmentInspectionData(data,query,this.usergroup,this.userid).SHIPMENT_INSP_LIST);
  }
  setAgentInvoiceActive(value: string) {
    this.isAgentInvoiceActiveSub.next(value);
  }
  returnAgentInvoiceActive(): Observable<string> {
    if(this.isAgentInvoiceActiveSub.getValue() != '' && this.isAgentInvoiceActiveSub.getValue() != undefined && this.isAgentInvoiceActiveSub.getValue() != null ){
      return this.isAgentInvoiceActiveObv;
    } else {
      this.getMasterData().subscribe((res:any)=>{
        if(res?.isAgentInvoiceActive != undefined){
          this.setAgentInvoiceActive(res.isAgentInvoiceActive);
        }
      });
      return this.isAgentInvoiceActiveObv;
    }
  }
}
